<template>
    <div>
        <TopBar :title="$t('site-add')" transparent />
        <LocationCreateForm type="Site" :location-types="[]" />
    </div>
</template>

<script setup lang="ts">
import TopBar from '@/components/TopBar.vue';
import LocationCreateForm from '@/location/forms/LocationCreateForm.vue';
</script>
